import { gql } from "@apollo/client";

export const fetchTargets = gql`
  query FetchTargets($brokerId: ID!) {
    fetchTargets(broker_id: $brokerId) {
      id
      broker_id
      target_name
      base_currency
      start_date
      end_date
      insurer_id
      target_badges {
        id
        name
        min_points
        max_points
        description
        minimum_cash_equivalent
        cash_equivalent
        gift_basket {
          gift_name
          gift_type
          gift_image
          gift_description
        }
      }
    }
  }
`;

export const fetchTarget = gql`
  query FetchTarget($targetId: ID!) {
    fetchTarget(target_id: $targetId) {
      id
      broker_id
      target_name
      base_currency
      start_date
      end_date
      insurer_id
      target_badges {
        id
        name
        min_points
        max_points
        description
        minimum_cash_equivalent
        cash_equivalent
        gift_basket {
          gift_name
          gift_type
          gift_image
          gift_description
        }
      }
    }
  }
`;
